import { useEffect, useState } from "react";
import HotdropdownV2 from "./HotdropdownV2";
import axios from "axios";
import { useTranslation } from "react-i18next";

function OrganizationEmployeeSelector({ value, onChange, disabled }) {
  const [employees, setEmployees] = useState([]);
  const { t } = useTranslation("general");

  useEffect(() => {
    const fetchEmployees = async () => {
      const data = await getAllOrganizationsEmployees();
      setEmployees(data || []);
    };

    fetchEmployees();
  }, []);

  const handleEmployeeSelect = (employee) => {
    if (employee.id === "unassigned") {
      onChange?.(null);
      return;
    }

    onChange?.(employee.id);
  };

  async function getAllOrganizationsEmployees() {
    const token = localStorage.getItem("token");
    const organizationId = localStorage.getItem("organizationId");
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/user`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "organizationid": organizationId,
          },
          params: {
            limit: 1000,
          },
        }
      );

      return response?.data?.users || [];
    } catch (error) {
      console.error(error);
    }
  }

  const employeeOptions = employees.map((employee) => ({
    id: employee.id,
    title: employee.username,
  }));

  const selected = employees.find((emp) => emp.id === value);

  if (selected) {
    employeeOptions.push({
      id: "unassigned",
      title: t("removeAssociation"),
    });
  }

  return (
    <HotdropdownV2
      selected={
        selected
          ? {
              id: selected?.id,
              title: selected.username,
            }
          : undefined
      }
      setSelected={handleEmployeeSelect}
      initOptions={employeeOptions}
      thick
    />
  );
}

export default OrganizationEmployeeSelector;
